import { useMutation, useQueryClient } from "@tanstack/react-query";
import { postCreateWorkflowView } from "apis";
import { TWorkflowView } from "@elixir/types";
import { useMyAccessProfileV2 } from "../get-my-access-profile";
import { getQueueConfigQueryKey } from "../get-queue-config";

export default function usePostCreateWorkflowView() {
  const queryClient = useQueryClient();

  const { data: myProfile } = useMyAccessProfileV2();
  const { user } = myProfile || {};

  return useMutation(
    (data: TWorkflowView) =>
      postCreateWorkflowView({ ...data, assigneeIds: [user?.oid!] }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getQueueConfigQueryKey());
      },
    }
  );
}
